import { Armchair } from 'lucide-react'

import type { CalendarGrouping } from '../calendar-model'
import styles from './LaneAvatar.module.css'

function initials(label: string) {
  const words = label.split(/[\s,.-]+/).filter((word) => /\p{L}/u.test(word))
  const first = words[0]?.[0] ?? ''
  const last = words.length > 1 ? (words.at(-1)?.[0] ?? '') : ''
  return `${first}${last}`.toUpperCase()
}

/** A provider's initials, or a chair for a room. Decorative: the name follows. */
export function LaneAvatar({
  label,
  grouping,
}: {
  label: string
  grouping: CalendarGrouping
}) {
  return (
    <span className={styles.avatar} aria-hidden="true">
      {grouping === 'room' ? <Armchair size={13} /> : initials(label)}
    </span>
  )
}
